import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { adminLogin, employeeLogin } = useAuth();
  const nav = useNavigate();
  const [tab, setTab]         = useState('admin');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [nic, setNic]         = useState('');
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);

  const handleAdmin = async e => {
    e.preventDefault(); setError(''); setLoading(true);
    try { await adminLogin(username, password); nav('/'); }
    catch(err) { setError(err.response?.data?.message || 'Login failed'); }
    setLoading(false);
  };

  const handleEmployee = async e => {
    e.preventDefault(); setError(''); setLoading(true);
    try { const u = await employeeLogin(nic); nav(`/me`); }
    catch(err) { setError(err.response?.data?.message || 'NIC not found'); }
    setLoading(false);
  };

  return (
    <div style={{minHeight:'100vh',background:'linear-gradient(135deg,#1a1f3c 0%,#2d3a6b 50%,#1a1f3c 100%)',display:'flex',alignItems:'center',justifyContent:'center',padding:24}}>
      <div style={{width:'100%',maxWidth:420}}>
        {/* Logo */}
        <div style={{textAlign:'center',marginBottom:32}}>
          <div style={{width:64,height:64,borderRadius:16,background:'#4f46e5',display:'inline-flex',alignItems:'center',justifyContent:'center',marginBottom:16}}>
            <svg width={32} height={32} fill="none" stroke="#fff" strokeWidth={1.8} viewBox="0 0 24 24">
              <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
            </svg>
          </div>
          <h1 style={{color:'#fff',fontSize:24,fontWeight:700,margin:0}}>EHRM</h1>
          <p style={{color:'rgba(255,255,255,0.5)',fontSize:13,marginTop:4}}>Employee HR Management System</p>
        </div>

        {/* Card */}
        <div style={{background:'#fff',borderRadius:16,padding:32,boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}}>
          {/* Tabs */}
          <div style={{display:'flex',background:'#f1f5f9',borderRadius:10,padding:4,marginBottom:24}}>
            {[['admin','Admin Login'],['employee','My Profile']].map(([k,l])=>(
              <button key={k} onClick={()=>{setTab(k);setError('');}}
                style={{flex:1,padding:'9px 0',border:'none',borderRadius:8,fontSize:13,fontWeight:600,cursor:'pointer',transition:'all .15s',
                  background:tab===k?'#fff':'transparent',
                  color:tab===k?'#1a1f3c':'#64748b',
                  boxShadow:tab===k?'0 1px 4px rgba(0,0,0,.1)':'none'}}>
                {l}
              </button>
            ))}
          </div>

          {error && <div style={{background:'#fee2e2',color:'#991b1b',border:'1px solid #fca5a5',borderRadius:8,padding:'10px 14px',fontSize:13,marginBottom:16}}>{error}</div>}

          {tab==='admin' ? (
            <form onSubmit={handleAdmin}>
              <div style={{marginBottom:16}}>
                <label style={{fontSize:12,fontWeight:600,color:'#374151',display:'block',marginBottom:5}}>Username</label>
                <input value={username} onChange={e=>setUsername(e.target.value)} placeholder="admin" required autoFocus
                  style={{width:'100%',padding:'10px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,outline:'none',boxSizing:'border-box'}}/>
              </div>
              <div style={{marginBottom:24}}>
                <label style={{fontSize:12,fontWeight:600,color:'#374151',display:'block',marginBottom:5}}>Password</label>
                <input type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="••••••••" required
                  style={{width:'100%',padding:'10px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,outline:'none',boxSizing:'border-box'}}/>
              </div>
              <button type="submit" disabled={loading} style={{width:'100%',padding:'11px',background:'#4f46e5',color:'#fff',border:'none',borderRadius:8,fontSize:14,fontWeight:600,cursor:'pointer',opacity:loading?.7:1}}>
                {loading?'Signing in…':'Sign In as Admin'}
              </button>
            </form>
          ) : (
            <form onSubmit={handleEmployee}>
              <div style={{marginBottom:8}}>
                <label style={{fontSize:12,fontWeight:600,color:'#374151',display:'block',marginBottom:5}}>Your NIC Number</label>
                <input value={nic} onChange={e=>setNic(e.target.value)} placeholder="e.g. 200012345678" required autoFocus
                  style={{width:'100%',padding:'10px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,outline:'none',boxSizing:'border-box'}}/>
              </div>
              <p style={{fontSize:12,color:'#9ca3af',marginBottom:20}}>Enter your NIC number to view your profile and request status.</p>
              <button type="submit" disabled={loading} style={{width:'100%',padding:'11px',background:'#4f46e5',color:'#fff',border:'none',borderRadius:8,fontSize:14,fontWeight:600,cursor:'pointer',opacity:loading?.7:1}}>
                {loading?'Searching…':'View My Profile'}
              </button>
            </form>
          )}

          {/* Guest link */}
          <div style={{borderTop:'1px solid #f1f5f9',marginTop:20,paddingTop:16,textAlign:'center'}}>
            <p style={{fontSize:12,color:'#9ca3af',marginBottom:8}}>Not registered in the system?</p>
            <Link to="/request-letter" style={{display:'inline-flex',alignItems:'center',gap:6,padding:'9px 18px',borderRadius:8,border:'1px solid #e5e7eb',color:'#4f46e5',fontSize:13,fontWeight:600,textDecoration:'none',background:'#f8fafc',transition:'all .15s'}}>
              <svg width={14} height={14} fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>
              Request a Letter (No Account)
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
